import { useCallback, useEffect, useState } from "react";

import { useIMask } from "react-imask";

import { updateMaskPlaceholder } from "../../../../utils/ui/inputs/masks";

import type { IUseInputMask } from "../types";
import type { FactoryOpts } from "imask";

/**
 * Хук для управления маской инпута
 */
export const useInputMask = ({
    value = "",
    onChange,
    mask,
    ref,
}: IUseInputMask) => {
    const [maskPlaceholder, setMaskPlaceholder] = useState({
        value: "",
        placeholder: "",
    });

    const acceptMaskHandler = useCallback(
        (value: string, maskRef: { value: string }, e?: InputEvent) => {
            if (mask) {
                setMaskPlaceholder(
                    updateMaskPlaceholder(mask.placeholder, maskRef.value),
                );
            }
            if (e) {
                onChange?.(
                    e as unknown as Parameters<
                        Exclude<typeof onChange, undefined>
                    >[0],
                );
            }
        },
        [mask, onChange],
    );

    const { setValue } = useIMask(
        {
            mask: mask?.mask,
            lazy: true,
        } as FactoryOpts,
        {
            ref,
            onAccept: acceptMaskHandler,
        },
    );

    useEffect(() => {
        if (mask) {
            setMaskPlaceholder(
                updateMaskPlaceholder(
                    mask.placeholder,
                    ref?.current?.value || "",
                ),
            );
        }
    }, [mask, ref]);

    useEffect(() => {
        setValue(value);
    }, [value, setValue]);

    return {
        maskPlaceholder,
    };
};
